import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const BotonAgregar = ({ onClick }) => {
    return (
        <Bootstrap.Form.Group as={Bootstrap.Col} md="12">
            <div className={"display-flex flex-end"}>
                <Bootstrap.Button
                    onClick={onClick}
                >
                    Agregar
                </Bootstrap.Button>
            </div>
        </Bootstrap.Form.Group>
    )
}

export default BotonAgregar